var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable i18next/no-literal-string -- Dev tools don't use translations */
import { useMemo } from 'react';
import { Typography } from '@lucidlink/uicore';
import { useSerializedStats } from '../../../query-hooks';
import { MetricsTable } from './components';
export const ObjectStoreMetrics = ({ stats }) => {
    _react_refresh_temp_2();
    const { query: { data: serializedStats }, } = useSerializedStats('object_store', stats);
    const metrics = useMemo(() => {
        if (!serializedStats) {
            return undefined;
        }
        return [
            {
                name: 'BucketExists Calls',
                value: serializedStats?.bucketExists.success.count,
            },
            {
                name: 'CreateBucket Calls',
                value: serializedStats?.createBucket.success.count,
            },
            {
                name: 'GetObject Calls',
                value: serializedStats?.getObject.success.count,
            },
            {
                name: 'PutObject Calls',
                value: serializedStats?.putObject.success.count,
            },
            {
                name: 'HeadObject Calls',
                value: serializedStats?.headObject.success.count,
            },
        ];
    }, [serializedStats]);
    return metrics ? (_jsx(MetricsTable, { data: metrics })) : (_jsx(Typography, { color: "negative", kind: "h5", children: "Cannot load Object Store metrics" }));
};
_react_refresh_temp_1 = ObjectStoreMetrics;
$RefreshReg$(_react_refresh_temp_1, "ObjectStoreMetrics");
_react_refresh_temp_2(ObjectStoreMetrics, "k0uoxYknZnRVwSi4YJ838faW2Ms=", false, () => [useSerializedStats]);
